import { action, makeObservable, observable } from 'mobx';
import type { BoloPanelMetadata } from '@mark43/cad-api';
import { O } from 'ts-toolbelt';

const defaultOptionalMetadataValues: {
    [Key in O.OptionalKeys<BoloPanelMetadata>]: undefined;
} = {
    actualExpirationDateUtc: undefined,
};

export class BoloPanelMetadataStore {
    @observable
    public readonly state: { metadata?: BoloPanelMetadata } = { metadata: undefined };

    constructor(initialMetadata?: BoloPanelMetadata) {
        if (initialMetadata) {
            this.setBoloPanelMetadata(initialMetadata);
        }
        makeObservable(this);
    }

    @action
    setBoloPanelMetadata(boloPanelMetadata: BoloPanelMetadata): void {
        if (this.state.metadata) {
            Object.assign(this.state.metadata, defaultOptionalMetadataValues, boloPanelMetadata);
        } else {
            this.state.metadata = boloPanelMetadata;
        }
    }
}
